var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "51px",
    viewBox: "0 0 130 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_positiv") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.9998627%",
    x2: "100.000186%",
    y2: "49.9998627%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89959F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012639",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.4039735%",
    y1: "104.140186%",
    x2: "57.6269782%",
    y2: "49.317388%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.2399813%",
    y1: "-56.2458176%",
    x2: "51.341201%",
    y2: "130.964959%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.7355,
    offset: "8.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000773514852%",
    y1: "50.0002005%",
    x2: "99.9995359%",
    y2: "50.0002005%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89959F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012639",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.389913%",
    y1: "58.3696663%",
    x2: "99.3468138%",
    y2: "44.2615839%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.6373,
    offset: "8.96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000106656996%",
    y1: "50.0003995%",
    x2: "100.00016%",
    y2: "50.0003995%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89959F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012639",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.58823%",
    y1: "89.1058119%",
    x2: "58.7153504%",
    y2: "-6.84638752%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "5.41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_positiv",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_positiv_stor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-1)",
    points: "65.514246 18.6192823 0.121622681 21.1423226 0.129406532 3.51807279 65.514246 5.82303374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5463312,5.41059507 L65.5164353,5.8240019 L65.5125432,18.6219447 L41.4723611,19.5477534 C41.4726044,19.5479954 47.7052803,10.7768965 53.5463312,5.41059507 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6120624,8.16526908 L45.9239945,13.5417362 L41.4154417,19.5552566 L0.112865848,21.1401442 L0.129163287,12.2487507 C0.129163287,12.2485087 18.0205894,9.2617169 50.6120624,8.16526908 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-4)",
    points: "75.4374406 30.9171674 59.7741421 25.5375537 59.7673312 12.8361854 75.4907114 6.7764351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6222106,9.81018289 L75.4858468,6.77716121 L75.4364674,30.9169254 L64.0457739,27.0026307 C64.0457739,27.0026307 64.9462681,15.9861131 67.6222106,9.81018289 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-6)",
    points: "70.1787195 24.3106454 115.79136 21.4056637 115.787711 3.32976453 70.1787195 0.0769691881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.627109,22.0526406 L115.791846,21.4051796 L115.784792,3.32807024 L88.689448,1.39924175 C88.689448,1.39924175 99.2713508,10.248278 105.627109,22.0526406 Z",
    id: "Shape",
    fill: "url(#linearGradient-7)",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(51.028037, 33.411215)",
    fill: "#012639"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1497164,10.4603454 L11.1497164,0.141648775 L12.7690084,0.141648775 L12.7690084,10.6472266 C12.7690084,12.6241197 13.7697274,13.0131182 13.7697274,13.0131182 L12.3673028,13.4899628 C12.3673028,13.4902008 11.1497164,12.7083948 11.1497164,10.4603454 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70897833,13.5520977 C0.925169992,13.5520977 0.0623462863,11.2461986 0.0623462863,7.94971013 C0.0623462863,4.65250758 0.925169992,2.34732255 4.70897833,2.34732255 C8.51576925,2.34732255 9.35683286,4.65274565 9.35683286,7.94971013 C9.35683286,11.2461986 8.51576925,13.5520977 4.70897833,13.5520977 Z M4.70897833,3.68310621 C1.78823819,3.68310621 1.61049015,5.51430348 1.61049015,7.94971013 C1.61049015,10.3848788 1.78823819,12.2165521 4.70897833,12.2165521 C7.5864428,12.2165521 7.80722199,10.3848788 7.80722199,7.94971013 C7.80722199,5.51430348 7.58619829,3.68310621 4.70897833,3.68310621 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9249964,16.1348668 C14.2303564,15.9632218 15.7577182,15.3373484 15.7577182,13.6782723 L15.7577182,2.94605645 L17.2620974,2.94605645 L17.2620974,13.8730096 C17.2620974,16.113917 14.9386592,17.2987673 12.9249964,17.4061348 L12.9249964,16.1348668 L12.9249964,16.1348668 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 15.7706765,
    y: 0.140458449,
    width: 1.49679986,
    height: 1.71644986
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0784656,5.80069588 C35.393131,5.56763009 36.0603585,5.09840364 36.0603585,5.09840364 C36.8933538,4.49490844 37.5116822,3.75190705 37.4728075,2.69704029 C37.4131507,1.12461986 36.1146365,-0.0321387977 34.4241963,0.0276155595 C32.696104,0.0892744377 31.4868305,1.3176907 31.5459984,2.88915888 C31.5904965,4.07329502 32.4217803,4.9510413 33.1166358,5.70451755 C31.6706909,6.71843712 30.2653323,7.76925676 30.3394144,9.74686408 C30.4259657,12.0401459 32.1359654,13.5171022 34.7567099,13.4233045 C36.9219597,13.3456953 38.1551937,12.2472626 38.6862374,11.7282805 L39.3923396,12.4374766 L40.424843,11.5133077 L35.0784656,5.80069588 Z M32.9694497,2.82107224 C32.9354648,1.9328511 33.5386346,1.26293572 34.469428,1.22960659 C35.3811507,1.1960394 36.0904314,1.85786057 36.1234382,2.74512945 C36.1525332,3.50384314 35.5809034,3.98616317 34.9706432,4.43443988 C34.9706432,4.43443988 34.4892321,4.78415762 34.2672304,4.94080449 C33.3342365,3.91879073 32.9919432,3.43051907 32.9694497,2.82107224 Z M34.6914296,12.1853656 C33.0198157,12.24512 31.8024739,11.2328669 31.7430615,9.66020839 C31.6870722,8.16277849 32.8173736,7.38263895 33.9471861,6.56321864 L34.4985229,6.19897893 C34.4985229,6.19897893 34.2420474,6.86199041 34.6112352,7.28669864 L37.833438,10.7953031 C36.7134053,11.8532647 35.6970385,12.1487036 34.6914296,12.1853656 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3589422,7.07815356 C64.2655741,6.9084131 63.8729146,6.41966535 63.8729146,5.4854976 C63.8729146,4.44539088 64.3313432,3.65977582 66.4895023,3.65977582 C67.492911,3.65977582 68.5461965,3.6852488 69.1073129,3.70119916 L69.5163537,2.43921571 L69.5163537,2.41374274 C69.5163537,2.41374274 67.5364312,2.34422771 66.5110179,2.34422771 C63.4367348,2.34422771 62.433571,3.97854509 62.433571,5.4854976 C62.433571,6.95078873 63.0868623,8.03374717 66.2494081,8.3096647 C68.4080569,8.47988129 68.713187,9.15860509 68.713187,10.1361007 C68.713187,11.1333556 68.1026821,12.0682376 65.8352336,12.0682376 C64.7567651,12.0682376 63.6606926,12.0377652 63.094197,12.0194342 L62.6998262,13.2366614 L62.6998262,13.315699 C62.6998262,13.315699 64.7665449,13.3840238 65.81274,13.3840238 C69.1276063,13.3840238 70.1965392,11.7499444 70.1965392,10.1149129 C70.196784,8.37370421 69.454741,7.35430915 66.3589422,7.07815356 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0862,7.07815356 C72.9935651,6.9084131 72.6009056,6.41966535 72.6009056,5.4854976 C72.6009056,4.44539088 73.0593342,3.65977582 75.217494,3.65977582 C76.2297037,3.65977582 77.2905687,3.68548687 77.8477736,3.70143723 L78.2441005,2.47897259 L78.2441005,2.41374274 C78.2441005,2.41374274 76.264178,2.34422771 75.2390096,2.34422771 C72.1647258,2.34422771 71.1613178,3.97854509 71.1613178,5.4854976 C71.1613178,6.95078873 71.8153423,8.03374717 74.9773992,8.3096647 C77.1360479,8.47988129 77.442156,9.15860509 77.442156,10.1361007 C77.442156,11.1333556 76.8311621,12.0682376 74.5639579,12.0682376 C73.4933131,12.0682376 72.4053097,12.0382414 71.8349019,12.0196722 L71.428062,13.2757041 L71.428062,13.315699 C71.428062,13.315699 73.495025,13.3840238 74.5409752,13.3840238 C77.8555973,13.3840238 78.9245308,11.7499444 78.9245308,10.1149129 C78.924775,8.37370421 78.18371,7.35430915 75.0862,7.07815356 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7470892,2.27495075 C19.9657258,2.27495075 19.0476462,4.80320283 19.0476462,7.93899721 C19.0476462,11.0774103 19.9654813,13.604234 23.7470892,13.604234 C24.709178,13.604234 25.861484,13.5194828 26.9763823,13.1309605 L27.4379894,11.7061404 L27.4379894,11.6430532 C26.3416727,12.1015667 25.3570903,12.2529761 23.7470892,12.2529761 C21.6194916,12.2529761 20.9185238,11.0347967 20.6952996,9.52022609 L20.6979891,9.5228448 C20.5904111,8.57034604 22.013129,8.63938497 22.013129,8.63938497 L22.009706,8.63652819 L27.99715,8.63652819 L27.99715,7.93875914 C27.99715,4.80320283 27.5497237,2.27495075 23.7470892,2.27495075 Z M22.1101936,7.39501829 C20.9774471,7.41572996 20.6043474,7.93375979 20.6043474,7.93375979 C20.6043474,7.73402312 20.6094818,7.54690391 20.6163277,7.39501829 L20.6138827,7.39501829 C20.6813634,5.43455166 21.1500608,3.62573251 23.7470892,3.62573251 C26.3196681,3.62573251 26.4318915,5.45550139 26.4318915,7.39501829 L22.1101936,7.39501829 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4408495,2.94605645 C49.4408495,2.94605645 48.0027285,2.34708449 46.2890614,2.34708449 C42.5050085,2.34708449 41.6424293,4.65250758 41.6424293,7.94947212 C41.6424293,11.2461986 42.5050085,13.5518597 46.2890614,13.5518597 C47.7230259,13.5518597 48.7349917,13.2240439 49.4408495,12.6405462 L49.4408495,13.6780342 C49.4408495,15.3373484 47.9134877,15.9632218 46.6076387,16.1346287 C46.6076387,16.1346287 46.1863734,16.1815275 45.8291658,16.1401042 L46.2433408,17.4182761 C46.4411374,17.414229 46.6073942,17.4056586 46.6073942,17.4056586 C48.6213015,17.2982912 50.9452287,16.1134409 50.9452287,13.8725335 L50.9452287,2.94558032 L49.4408495,2.94558032 L49.4408495,2.94605645 Z M46.2890614,12.2163141 C43.3683212,12.2163141 43.1910622,10.3846407 43.1910622,7.94947212 C43.1910622,5.51430348 43.3683212,3.68286815 46.2890614,3.68286815 C49.1660369,3.68286815 49.3873051,5.51406542 49.3873051,7.94947212 C49.3873051,10.3846407 49.1660369,12.2163141 46.2890614,12.2163141 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8057796,2.34708449 C55.91435,2.34708449 54.8693773,2.47064031 53.9803927,2.75060495 L53.5055829,4.21589606 C54.3632722,3.93712175 55.3336738,3.68310621 56.8057796,3.68310621 C58.8636961,3.68310621 59.4392379,4.37206681 59.4392379,5.94543951 L59.4392379,7.29764969 C59.1617358,6.78676184 57.7527097,6.69129767 57.7527097,6.69129767 L56.4737551,6.72105583 C53.2207459,7.00102049 52.5794349,8.46678768 52.5794349,10.082536 C52.5794349,11.8927836 53.5967796,13.5520977 56.4962486,13.5520977 C59.2292165,13.5520977 60.9883598,12.0227671 60.9883598,12.0227671 L60.9883598,5.96686537 C60.9878707,3.8116614 60.1257805,2.34708449 56.8057796,2.34708449 Z M59.4389934,11.3533278 C58.4879069,11.8925455 57.7348616,12.2163141 56.5397688,12.2163141 C54.4373543,12.2163141 54.1500723,11.0521754 54.1500723,10.0822979 C54.1500723,9.04861896 54.4820969,8.05683948 56.3629988,7.88400418 L57.686696,7.87233899 C57.686696,7.87233899 59.4392379,7.93614043 59.4392379,9.0212415 L59.4392379,11.3533278 L59.4389934,11.3533278 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 33.411215)",
    fill: "#646363"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7432979,7.07937282 L48.5142931,2.48063617 L46.4279266,2.48063617 L41.4140701,7.48137316 L41.4140701,0.164476963 L39.9050169,0.164476963 L39.9050169,13.6439892 L41.4140701,13.6439892 L41.4140701,10.5966306 C41.4140701,10.5966306 41.3658388,9.89313 41.7129575,9.17688309 C41.9373059,8.71213151 42.2707835,8.462352 42.7109545,8.05961632 L43.1630614,7.61422939 C42.9533286,8.00005165 43.2466135,8.51652404 43.4010509,8.74326202 L47.1825749,13.6439892 L49.1132861,13.6439892 L43.7432979,7.07937282 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "10.4888329 13.7317429 1.60332331 3.00372684 1.64741348 13.7317429 0.148591191 13.7317429 0.148591191 0.164231841 1.27276881 0.164231841 10.1582784 10.9753443 10.1141883 0.141680603 11.6134978 0.141680603 11.6134978 13.7314978 10.4888329 13.7314978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8789306,13.9538236 C14.1088554,13.9538236 13.2492188,11.5795704 13.2492188,8.18536398 C13.2492188,4.7904222 14.1088554,2.41690441 17.8789306,2.41690441 C21.672147,2.41690441 22.5096167,4.79066732 22.5096167,8.18536398 C22.5096167,11.5795704 21.672147,13.9538236 17.8789306,13.9538236 Z M17.8789306,3.7922848 C14.9692227,3.7922848 14.7926184,5.67776439 14.7926184,8.18536398 C14.7926184,10.6927184 14.9692227,12.5786883 17.8789306,12.5786883 C20.7457662,12.5786883 20.966217,10.6927184 20.966217,8.18536398 C20.966217,5.67776439 20.7457662,3.7922848 17.8789306,3.7922848 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9866767,2.36787998 C29.5718393,2.301697 29.1779508,2.25904574 28.6751768,2.25904574 C27.4406519,2.25904574 26.1617933,2.63506313 25.1255524,3.16305624 L23.9348741,3.15447697 L23.9348741,13.5738843 L25.4782738,13.5738843 L25.4782738,5.62555337 C25.4782738,4.22590589 27.1761109,3.63442613 28.6751768,3.63442613 C29.0159621,3.63442613 29.3097342,3.66212494 29.5664803,3.70796278 L29.9866767,2.36787998 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0342033,7.28797179 C31.948324,7.11319973 31.5578458,6.6099639 31.5578458,5.64810461 C31.5578458,4.57716593 32.0138503,3.76826283 34.1647686,3.76826283 C35.1574065,3.76826283 36.1746472,3.84523119 36.7356399,3.89597147 L37.1451182,2.55196671 C36.7229731,2.51397278 35.1937018,2.41371782 34.1862048,2.41371782 C31.1227903,2.41371782 30.1233319,4.09648139 30.1233319,5.64810461 C30.1233319,7.15683144 30.7751844,8.2718921 33.925074,8.5559887 C36.0759924,8.73125105 36.3807262,9.4300943 36.3807262,10.4365658 C36.3807262,11.4633825 35.7717458,12.4259772 33.5129161,12.4259772 C32.4588931,12.4259772 31.5880513,12.3475381 30.8433901,12.293121 L30.4183219,13.6540392 C30.9664042,13.7077209 32.4700983,13.7829734 33.4907493,13.7810125 C36.7926404,13.774149 37.8576251,12.098494 37.8576251,10.4149951 C37.8578687,8.62192652 37.1197846,7.5723135 34.0342033,7.28797179 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3fd6d6c4.svg";
export { ForwardRef as ReactComponent };